import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import cn from 'classnames';
import { GridUserDataContainer } from './GridUserDataStyles';
import NewsBlock from '../NewsBlock';

const GridUserData = observer(() => {
  const {
    appStore: { width },
    profileStore: { isNoAdv },
  } = useStores();

  const userDataGridClassName = cn('user-data-grid', isNoAdv && 'hide');

  return (
    <GridUserDataContainer>
      <div className="grid-user-data">
        <div className={userDataGridClassName} min-screen-width="400">
          <span ati-userdata-info="doc-preset=allpages_300_300" />
        </div>

        <div className={userDataGridClassName} min-screen-width="400">
          <span ati-userdata-info="doc-preset=allpages_300_300;doc-extra-content=lastNews;doc-extra-content-container=bottomNewsContainer" />
        </div>

        {width < 1544 && <NewsBlock className="news-block" />}
      </div>
    </GridUserDataContainer>
  );
});

export default GridUserData;
